import {Base, model, belongsTo, hasMany, getFrom, endpoint} from '@scoutgg/ftw/source/lib/model'

const MAP_EVENTS = {
  csgo: [
    'match_started',
    'map_started',
    'half_started',
    'round_started',
    'round_ended',
    'half_ended',
    'map_ended',
    'match_ended',
  ],
}

@model('Event')
@endpoint('events', {root: '/api'})
@belongsTo('subEvent', 'Event')
@belongsTo('mainEvent', 'Event')
@belongsTo('match')
@belongsTo('player')
@belongsTo('team')
@hasMany('subEvents', {
  foreign: 'mainEvent',
  className: 'Event',
})
@getFrom('match', [
  'rules',
])
export class Event extends Base {
  get side() {
    if((MAP_EVENTS[this.match.sport] || []).includes(this.name)) {
      return 'match'
    }
    if(!this.team) return 'match'
    return ['away', 'home'][+(this.match.homeTeam === this.team)]
  }
  get icon() {
    var type = this.name
    if(!this.name) return
    if(this.name === 'assist_fantasy') type = 'assist'
    if(this.name === 'assist_power') type = 'assist'
    if(this.name === 'assist_even') type = 'assist'
    if(this.name === 'assist_box') type = 'assist'
    if(this.name.match('caused')) type = 'blunder'
    if(this.name === 'goal_power') type = 'goal'
    if(this.name === 'goal_even') type = 'goal'
    if(this.name === 'goal_box') type = 'goal'
    return `events--${this.match.sport}--${type}`
  }
  get counter() {
    let seconds = this.second || 0
    seconds = seconds < 10 ? `0${seconds}` : seconds

    const { rules } = this
    if(this.batch && rules?.hasTag('periods')) {
      const [batch, minute] = rules.eventRound(this)
      return `${batch} - ${minute}:${seconds}`
    }
    return [this.minute, seconds].join(':')
  }
  get seconds() {
    return this.minute * 60 + (this.second || 0)
  }
  get isValid() {
    return this.validity !== 'invalid'
  }
}
